module.exports = __webpack_public_path__ + "img/M5.ccb7c607.png";